// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "public_site".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "public_site" table (1:1 with a DB row, on the wire). */
export const publicSiteAtomSchema = z.object({
    locationId: z.string(),
    organizationId: z.string(),
    customDomain: z.string().nullable(),
    publishedHtml: z.string().nullable(),
    publishedUrl: z.string().nullable(),
    revision: z.number(),
    state: z.unknown(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=publicSite.js.map